import React from 'react';

import { withEventScope } from '@repo/event-processor';
import {
  subscriptionStoreSelector,
  useSubscriptionStore,
} from '@repo/subscription/client';

import ChangeSubscriptionActions from '../../ActionButtons/ChangeSubscriptionActions/ChangeSubscriptionActions';
import ProceedToCheckoutButton from '../../ActionButtons/CreateSubscriptionActions/ProceedToCheckoutButton';
import useSubscriptionPreview from '../../hooks/useSubscriptionPreview';

import PlanPaymentDetails from './PlanPaymentDetails';
import PlanSelectionDetails from './PlanSelectionDetails';
import { PlanPurchaseDetailsProps } from './types';

/**
 * This component mounts the plan selection details and payment details components.
 */
const PlanPurchaseDetails: React.FC<PlanPurchaseDetailsProps> = ({
  onPaymentSuccess,
  onPaymentInit,
  subscriptionFlowState,
  returnUrlParams,
}) => {
  const currentSubscription = useSubscriptionStore(
    subscriptionStoreSelector.subscription
  );

  const subscriptionChangePreviewData = useSubscriptionPreview({
    currentSubscription,
  });

  if (subscriptionFlowState === 'selection' && currentSubscription?.plan) {
    return (
      <PlanSelectionDetails
        actionButtons={
          <ChangeSubscriptionActions
            currentSubscription={currentSubscription}
            subscriptionChangePreviewData={subscriptionChangePreviewData}
          />
        }
        currentSubscription={currentSubscription}
        subscriptionChangePreviewData={subscriptionChangePreviewData}
      />
    );
  } else if (subscriptionFlowState === 'selection') {
    return (
      <PlanSelectionDetails
        actionButtons={<ProceedToCheckoutButton onSuccess={onPaymentInit} />}
        currentSubscription={currentSubscription}
        subscriptionChangePreviewData={subscriptionChangePreviewData}
      />
    );
  } else if (subscriptionFlowState === 'past-due') {
    return (
      <PlanPaymentDetails
        layout="accordion"
        returnUrlParams={returnUrlParams}
        subscriptionChangePreviewData={subscriptionChangePreviewData}
        onPaymentSuccess={onPaymentSuccess}
      />
    );
  }

  return (
    <PlanPaymentDetails
      returnUrlParams={returnUrlParams}
      subscriptionChangePreviewData={subscriptionChangePreviewData}
      onPaymentSuccess={onPaymentSuccess}
    />
  );
};

export default withEventScope(PlanPurchaseDetails, {
  module: 'planPurchaseDetails',
});
